var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseenter":function($event){_vm.showme = true},"mouseleave":function($event){_vm.showme = false}}},[_c('div',{staticClass:"main",class:{ active: _vm.showme && _vm.color },style:({ color: _vm.fgcolor })},[_vm._t("default")],2),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showme),expression:"showme"}],staticClass:"hover",style:({
        height: _vm.h + 'px',
        width: _vm.w + 'px',
        top: _vm.t + 'px',
        left: _vm.l + 'px',

        'background-color': _vm.bgcolor,
      })})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }